import { MediaType } from "constants/enums";
import {
  validateVideoFiles,
  getFileWithDimensions,
  getFileMediaType
} from "helpers";
import { useDirectUploadToS3 } from "libs/directUpload";
import { useState } from "react";
import { FileWithPath } from "react-dropzone";
import { toast } from "react-hot-toast";

import { FilesUploaderProps } from "./FilesUploader.types";

const FilesUploader = ({
  children,
  onSuccessUploading,
  additionalValidator,
  uploadDirectoryKey,
  onVideoFileReceived
}: FilesUploaderProps) => {
  const { uploader } = useDirectUploadToS3();

  const [loadingFilesCounter, setLoadingFilesCounter] = useState(0);

  const subtractFilesCounter = () => {
    setLoadingFilesCounter((prev) => prev - 1);
  };

  const uploadDroppedFiles = async (files: FileWithPath[]) => {
    const filesWithMetadata = await Promise.all(
      files.map(async (file) => await getFileWithDimensions(file))
    );

    const filteredFilesByVideo = filesWithMetadata.filter(
      (file) => getFileMediaType(file) === MediaType.VIDEO
    );
    const isVideoFilesValid = await validateVideoFiles(filteredFilesByVideo);

    const isAdditionalValidationValid =
      additionalValidator?.(filesWithMetadata) ?? true;

    if (!isVideoFilesValid || !isAdditionalValidationValid) {
      return;
    }

    setLoadingFilesCounter(files.length);

    for await (const file of filesWithMetadata) {
      if (getFileMediaType(file) === MediaType.VIDEO && onVideoFileReceived) {
        onVideoFileReceived(file);
      }

      await uploader(file, {
        directoryKey: uploadDirectoryKey,
        onSuccess: onSuccessUploading,
        onError: () =>
          toast.error(`Something went wrong with ${file.name} file uploading`)
      });

      subtractFilesCounter();
    }
  };

  return (
    <>
      {children({
        loadingFilesCounter,
        onFilesDrop: uploadDroppedFiles
      })}
    </>
  );
};

export default FilesUploader;
